import { useState } from "react";
import { useGame } from "./games/useGame";
import { GameShell, cardCls } from "./games/GameShell";

const BUCKET_CLS = ["border-[#6B9080] bg-[#EEF3EF]", "border-[#C87D53] bg-[#FBF1EA]", "border-[#3B6EA8] bg-[#EAF1F9]"];

const Board = ({ g, onResult }) => {
  const [placed, setPlaced] = useState({});
  const [picked, setPicked] = useState(null);
  const [shake, setShake] = useState(null);
  const [missed, setMissed] = useState([]);
  const drop = (id, b) => {
    const item = g.items.find((x) => x.id === id);
    if (!item || placed[id] !== undefined) return;
    setPicked(null);
    if (item.bucket !== b) { setMissed((m) => (m.includes(id) ? m : [...m, id])); setShake(id); setTimeout(() => setShake(null), 450); return; }
    const next = { ...placed, [id]: b };
    setPlaced(next);
    if (Object.keys(next).length === g.items.length) onResult({ kind: g.kind, title: g.title, correct: g.items.length - missed.length, total: g.items.length });
  };
  const left = g.items.filter((x) => placed[x.id] === undefined);
  const web = g.kind === "concept";
  return (
    <div data-testid={`${g.kind}-game`}>
      <p className="font-display text-xl text-[#2C4A3E]" data-testid="game-title">{g.title}</p>
      <p className="text-xs text-stone-500 mt-1">Drag each card {web ? "onto the branch it connects to" : "into a group"}, or tap a card and then tap {web ? "the branch" : "the group"}.</p>
      <div className="mt-4 flex flex-wrap gap-2 min-h-[48px]" data-testid="sort-game-pool">
        {left.map((x) => (
          <button key={x.id} type="button" draggable onDragStart={(e) => e.dataTransfer.setData("text/plain", x.id)} onClick={() => setPicked(picked === x.id ? null : x.id)}
            data-testid={`sort-item-${x.id}`} aria-pressed={picked === x.id} className={`${cardCls(picked === x.id, shake === x.id)} px-4 py-2.5 text-sm`}>{x.text}</button>))}
      </div>
      {web && <div className="mt-6 flex justify-center"><span className="px-6 py-3 rounded-full bg-[#2C4A3E] text-white font-display text-lg shadow-lg" data-testid="concept-center">{g.center}</span></div>}
      <div className={`grid gap-4 ${web ? "mt-0 sm:grid-cols-3" : "mt-5 sm:grid-cols-2"}`}>
        {g.buckets.map((b, i) => (
          <div key={i} className="flex flex-col items-center">
            {web && <span className="w-px h-6 bg-[#2C4A3E]/40" />}
            <div onDragOver={(e) => e.preventDefault()} onDrop={(e) => drop(e.dataTransfer.getData("text/plain"), i)} onClick={() => picked && drop(picked, i)}
              data-testid={`sort-bucket-${i}`} className={`w-full rounded-3xl border-2 border-dashed p-4 min-h-[150px] transition-colors ${BUCKET_CLS[i]} ${picked ? "cursor-pointer" : ""}`}>
              <p className="text-xs uppercase tracking-widest font-semibold text-[#2C4A3E] text-center">{b}</p>
              <div className="mt-3 flex flex-wrap gap-2">{g.items.filter((x) => placed[x.id] === i).map((x) => <span key={x.id} className="px-3 py-1.5 rounded-xl bg-white text-sm text-[#2C4A3E]" data-testid={`sort-placed-${x.id}`}>{x.text}</span>)}</div>
            </div>
          </div>))}
      </div>
    </div>
  );
};

export const SortGame = ({ req, lesson, onResult, kind = "sort" }) => {
  const { g, err, load } = useGame(kind, req, lesson);
  return <GameShell g={g} err={err} load={load}>{g && <Board g={g} onResult={onResult} />}</GameShell>;
};
